import React, { useState, useRef, useEffect } from "react";
import BASEURL from "../Utils/Baseurl";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Card,
  Grid2,
  Box,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
  Divider,
  List,
  ListItem,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialButton from "../../components/MaterialButton";
import { toWords } from "number-to-words";
import keelLogo from "../../assest/images/Keel.png";
import html2canvas from "html2canvas";
import axios from "axios";
import { PDFDocument } from "pdf-lib";
import Swal from "sweetalert2";
import "./File.css";
import { useUserDetails } from "../../context/auth";
import MaterialSelect from "../../components/MasterSelect";
import PayslipLayout from "./paysliplayout";
import { Download } from "@mui/icons-material";
const AddPayslip = () => {
  const getallemployee = `
    query activeUsersDetail{
        activeUsersDetail{
        id
        lastLogin
        username
        firstName
        lastName
        isSuperuser
        isActive
        dateJoined
        email
        salutation
        dateOfBirth
        contactNumber
        emergencyContact
        gender
        employeeType
        lastUpdate
        department
        designation
        empid
        teamleader 
        grade
        role{
        role
        }
        }}
    `;
  const employeedata = sessionStorage.getItem("user");
  const userObject = JSON.parse(employeedata);
  const { AccessData } = useUserDetails();

  const [userrowid, setuserrowid] = useState(userObject?.id);
  const [isDownloading , setIsDownloading] = useState(false);
  const [cangenerate_allpayslip, setcangenerate_allpayslip] = useState(false);

  console.log(cangenerate_allpayslip, "sdswd");

  const [payrollData, setPayrollData] = useState({
    month: "",
    monthStatus: "",
    year: "",
    yearStatus: "",
    empid: userObject.empid,
  });

  const currentYear = new Date().getFullYear();
  const startYear = 2000;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const [selectedMonth, setSelectedMonth] = useState("");

  const monthss = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const payslipRef = useRef();

  const [display, setdisplay] = useState(true);

 const downloadPDF = async () => {
  setIsDownloading(true);

  try {
    const element = payslipRef.current;
    const downloadButton = document.getElementById("downloadButton");

    if (downloadButton) downloadButton.style.display = "none";

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true,
      ignoreElements: (el) => {
        const style = window.getComputedStyle(el);
        return style.backgroundImage !== "none";
      },
    });

    const imageData = canvas.toDataURL("image/png");
    const pdfDoc = await PDFDocument.create();
    const image = await pdfDoc.embedPng(imageData);

    const imageWidth = 500;
    const imageHeight = (image.height / image.width) * imageWidth;

    const page = pdfDoc.addPage([
      imageWidth + 30,
      imageHeight + 30,
    ]);

    page.drawImage(image, {
      x: 15,
      y: 15,
      width: imageWidth,
      height: imageHeight,
    });

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], {
      type: "application/pdf",
    });

    const pdfUrl = URL.createObjectURL(pdfBlob);

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `Payslip_${cangenerate_allpayslip ? payrollData.empid?.label : payrollData.empid}_${selectedMonth}_${selectedYear}.pdf`;
    link.click();

    URL.revokeObjectURL(pdfUrl);
  } catch (error) {
    console.error("Error downloading payslip:", error);
  } finally {
    const downloadButton = document.getElementById("downloadButton");

    if (downloadButton) {
      downloadButton.style.display = "inline-block";
    }

    setIsDownloading(false);
  }
};

  const currentMonth = new Date().getMonth() + 1; // Get the current month (0-based index, so add 1)

  const [Earning, setEarning] = useState([]);
  const [Deductions, setDeductions] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  const [Userdetails, setUserdetails] = useState("");
  const [totaldata, settotaldata] = useState("");
  console.log("totaldata",totaldata);
  
  const [Showpayslip, setShowpayslip] = useState(false);
  const [allusers, setallusers] = useState([]);
  console.log(Deductions, "d94");

  useEffect(() => {
    getemployees();
  }, []);

  useEffect(() => {
    const data = AccessData.find(
      (access) =>
        access?.module == "Payroll" && access.component == "AddPayroll",
    );
    console.log(data, "kjwhfe");

    setcangenerate_allpayslip(data?.can_access || false);
  }, [AccessData]);
  const Runpayslip = async () => {
    const query = `
    query payslip($userId: Int!, $month: Int!, $year: Int!) {
  payslip(userId: $userId, month: $month, year: $year) {
    user {
      firstName
      lastName
      empid
      designation
      dateJoined
      panNumber
      uanNumber
      esicNumber
    }
    updatedCtc
    gross
    totalDeductions
    totalBenefits
    netPay
    netpayWithOtammount
    lossOfPayAmount
    overallSum
    otPerhourCharge
    overtime
    lossOfPayCount
    taxAmount
    breakdown
  }
}
    `;

    let varia = null;

    switch (selectedMonth) {
      case "January":
        varia = 1;
        break;
      case "February":
        varia = 2;
        break;
      case "March":
        varia = 3;
        break;
      case "April":
        varia = 4;
        break;
      case "May":
        varia = 5;
        break;
      case "June":
        varia = 6;
        break;
      case "July":
        varia = 7;
        break;
      case "August":
        varia = 8;
        break;
      case "September":
        varia = 9;
        break;
      case "October":
        varia = 10;
        break;
      case "November":
        varia = 11;
        break;
      case "December":
        varia = 12;
        break;
      default:
        console.error("No matching case found for:", currentMonth);
        return;
    }

    const variables = {
      month: varia,
      year: selectedYear,
      userId: userrowid,
    };

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      let payslipData = response.data.data.payslip;
      settotaldata(payslipData);
      if (response.data.data.payslip) {
        setShowpayslip(true);
      }
      if (response.data.data.payslip === null) {
        Swal.fire({
          position: "center",
          icon: "error", // Change 'success' to 'error'
          title: "PaySlip is not generated this month",
          showConfirmButton: false,
          timer: 2500,
        });
        setShowpayslip(false);
      }
      // Parse the stringified JSON breakdown field
      const breakdown = JSON.parse(payslipData?.breakdown);

      setUserdetails(payslipData.user);
      let earnings = breakdown.filter((val) => val.type == "Earnings");
      let deduction = breakdown.filter((val) => val.type == "Deductions");
      let benefits = breakdown.filter((val) => val.type == "Benefits");
      const gratuity = benefits.find(
        (item) => item.componentName === "GRATUITY",
      );
      const tax = {
        type: "Deductions",
        yearly: payslipData.taxAmount,
        monthly: (payslipData.taxAmount * 12).toFixed(2),
        percentage: 0.75,
        componentName: "Tax",
      };
      const finalData = [...deduction, gratuity, tax];

      setEarning(earnings);
      // setDeductions(finalData);
      setDeductions(deduction);
      setBenefits(benefits);
    } catch (error) {
      console.error("Error fetching payslip:", error);
    }
  };

  const getemployees = async () => {
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: getallemployee,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      let users = response.data.data.activeUsersDetail;

      users = users.filter((user) => user?.isSuperuser === false)
        .map((user) => ({
          value: user?.id,
          label: user?.firstName + " " + user?.lastName + " - " +user?.empid,
      }));
      setallusers(users);
    } catch (error) {
      console.error("Error fetching payslip:", error);
    }
  };

  const totalMonthly = Earning.reduce(
    (sum, earning) => sum + parseFloat(earning.monthly || 0),
    0,
  );
  const totalEarActuals = Earning.reduce(
    (sum, earning) => sum + parseFloat(earning.Actuals || 0),
    0,
  );
  const totalEarYtd = Earning.reduce(
    (sum, earning) => sum + parseFloat(earning.YTD || 0),
    0,
  );

  const totalYearly = Earning.reduce(
    (sum, earning) => sum + parseFloat(earning?.yearly || 0),
    0,
  );
  const totalAmount = Deductions.reduce(
    // (sum, deduction) => sum + (parseFloat(deduction?.yearly) || 0),
    (sum, deduction) => sum + (parseFloat(deduction?.monthly) || 0),
    0,
  );

  const totalYTD = Deductions.reduce(
    (sum, deduction) => sum + (parseFloat(deduction?.YTD) || 0),
    0,
  );
  const netPay = totaldata?.netPay;
  const amountInWords =
    typeof netPay === "number" && !isNaN(netPay) && netPay !== Infinity
      ? toWords(netPay)
      : "Invalid Amount";

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      selectedYear !== "" &&
      selectedMonth !== "" &&
      payrollData.empid !== ""
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlemonth = (e) => {
    let val = e.target.value;
    setSelectedMonth(val);
    setShowpayslip(false);
  };

  const handleemployee = (e) => {
    setPayrollData((prev) => ({
      ...prev,
      empid: e,
    }));

    setuserrowid(e?.value);
  };

  return (
    <DashboardLayout>
      <Card sx={{ overflow: "visible" }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Generate Pay Slip
                </MaterialTypography>
                <MaterialTypography variant="caption" fontWeight="medium">
                  Fill the form and generate Pay Slip
                </MaterialTypography>
              </Stack>

              {Showpayslip && (
                <Button
                  variant="contained"     
                  onClick={downloadPDF}
                  disabled={isDownloading}
                  startIcon={<Download />}
                  sx={{
                  backgroundColor: "#3f4277",
                  color: "#fff",
                  borderRadius: "5px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "8px 16px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.15)",

                  "&:hover": {
                      backgroundColor: "#34365f",
                  },

                  "&.Mui-disabled": {
                      backgroundColor: "#9a9cb8",
                      color: "#fff",
                      cursor: "not-allowed",
                  },
              }}
                >
                  {isDownloading ? "Downloading..." : "Download PDF"}
                </Button>
              )}
            </Stack>
          }
        />
        <CardContent>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Year <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <div className="dropdown-container">
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="custom-select"
                  >
                    <option value="" disabled>
                      Select...
                    </option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
                {payrollData.monthStatus === "uncheckedError" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Month <span style={{ color: "red" }}>*</span>
                </MaterialTypography>

                <div className="dropdown-container">
                  <select
                    value={selectedMonth}
                    onChange={handlemonth}
                    className="custom-select"
                  >
                    <option value="" disabled>
                      Select...
                    </option>
                    {monthss.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                {payrollData.monthStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    {cangenerate_allpayslip ? "Employee" : "Employee ID"}
                  </MaterialTypography>
                </MaterialBox>
                {
                  <>
                    {cangenerate_allpayslip ? (
                      <MaterialSelect
                        value={payrollData.empid}
                        customStyles={{ optionPadding: 20 }}
                        onChange={handleemployee} //selectedValue, event
                        options={allusers}
                        // error={source.sourceStatus === "error" ? true : false}
                        // success={source.sourceStatus === "success" ? true : false}
                      />
                    ) : (
                      <MaterialInput
                        value={payrollData.empid}
                        disabled={display}
                      />
                    )}
                  </>
                }

                {payrollData.monthStatus === "uncheckedError" && (
                  <FormControl error>
                    <FormHelperText>Employee Name is required</FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>

            <MaterialBox
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1%",
              }}
            >
              <MaterialButton
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={Runpayslip}
              >
                Generate
              </MaterialButton>
            </MaterialBox>
          </MaterialBox>

          {Showpayslip && (
            <PayslipLayout
              payslipRef={payslipRef}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              Userdetails={Userdetails}
              totaldata={totaldata}
              Earning={Earning}
              Deductions={Deductions}
              totalAmount={totalAmount}
              totalMonthly={totalMonthly}
              totalYearly={totalYearly}
              totalYTD={totalYTD}
              amountInWords={amountInWords}
              totalEarActuals={totalEarActuals}
              totalEarYtd={totalEarYtd}
            />
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AddPayslip;
